module.exports = __webpack_public_path__ + "img/ssyx_29.bccabf15.jpg";